import { fetcher } from "src/api/fetcher";
import { UserProfile } from "./schema/UserProfile";

export async function updateUser(
  options: UpdateUserProfile,
): Promise<UserProfile> {
  return await fetcher("/api/1.6/user/me", {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(options),
    schema: UserProfile,
  });
}

export async function deleteUser(): Promise<void> {
  await fetcher("/api/1.6/user/me", {
    method: "DELETE",
    credentials: "include",
  });
}

type UpdateUserProfile = {
  name?: string;
  profileCurrency?: string;
  isKilometers?: boolean;
  profileLanguage?: string;
  optedInMarketingEmails?: boolean;
  is24h?: boolean;
};
